
export const StarRate = ({rate = 0}) =>{
    let starDiv = [];
    for (let i = 1; i <= 5; i++) {
        starDiv.push(
            <div key={i} className='ranking-casino-item-content-vote-star'>
                {rate >= i ?
                    <img src="/assets/images/review-star-filled.svg" alt="" className="img-fluid w-100" />
                :
                    <img src="/assets/images/review-star-empty.svg" alt="" className="img-fluid w-100" />
                }
            </div>
        )
    }
    return(
        <div className='ranking-casino-item-content-vote-box'>
            <div className='d-flex'>
                {starDiv}
            </div>
        </div>
    )
}